export const ADDBOOKING = "booking/booking";
export const DELETEBOOKING = "booking/delete-booking";
